module.exports = __webpack_public_path__ + "img/logo-twisted-nerve.a1c7fd85.png";